import {SubmissionsService} from "@/services/submissions.service"

const state = {
    submissions: {}
}

const getters = {
    submissions: (state: { submissions: any }) => {
        return state.submissions;
    }
}

const actions = {
    async setSubmissions(context: any, data: any) {
        return new Promise((resolve, reject) => {
            SubmissionsService.setSubmissions(data)
                .then((res: any) => {
                    context.commit("submissionsSuccess", res);
                    resolve(res)
                })
                .catch((err: any) => {
                    console.log('actions.setSubmissions.err', err)
                    reject(err)
                })
        })
    },

    async getSubmissions() {
        return new Promise((resolve, reject) => {
            SubmissionsService.getSubmissions()
                .then((res: any) => {
                    resolve(res);
                })
                .catch((err: any) => {
                    console.log('actions.getSubmissions.err', err)
                    reject(err);
                });
        });
    },
}

const mutations = {
    submissionsSuccess(state: {
        submissions: any;
    }, submissions: any) {
        state.submissions = submissions
    },
}

export const submissions = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
